const getOpenedInlinePopup = (state: AnyFixMe) =>
  state.inlinePopup.openedInlinePopup;

const isInlinePopupOpened = (state: AnyFixMe): boolean =>
  !!getOpenedInlinePopup(state);

export { getOpenedInlinePopup, isInlinePopupOpened };
